import type { ReactNode } from 'react';

import type { FormikProps } from 'formik';
import toString from 'lodash/toString';

import { TextInputUnwired } from '..';

import type { PropsFromRedux } from './container';

interface ZipCodeEligibilityInputProps extends PropsFromRedux, FormikProps<any> {
  name: string;
  label: string;
  helperText?: string;
  errorMessage?: ReactNode;
  /**
   * compactStyle - Defaults to false
   */
  compactStyle?: boolean;
  customInputClassName?: string;
  data_cy?: string;
  /**
   * Set zip code callback
   */
  setIsZipCodeDeliverable?: (isDeliverable: boolean) => void;
}

const Renderer = ({
  name,
  label,
  helperText,
  handleChange,
  formik,
  dispatchFieldFocused,
  customInputClassName,
  compactStyle = false,
  data_cy,
}: ZipCodeEligibilityInputProps & { formik: FormikContext<any> }) => {
  const { values, touched, errors, handleBlur, status = {} } = formik;
  const value = toString(values[name]);

  const hasError = touched[name] && errors[name] && status?.isZipCodeDeliverable !== true;

  const errorMessage = hasError
    ? status?.isZipCodeDeliverable === false
      ? 'Please try another home or office address.'
      : errors[name]
    : '';

  return (
    <TextInputUnwired
      name={name}
      label={label}
      helperText={helperText}
      formik={formik}
      error={errorMessage}
      value={value}
      customInputClassName={customInputClassName}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={dispatchFieldFocused}
      isLoading={status?.submitting}
      compactStyle={compactStyle}
      type="text"
      data-cy={data_cy}
    />
  );
};
export default Renderer;
